/* Function for handling links inside of select inputs */

if ($('.wex-link--select').length !== 0) {

  var selectInput = $('.wex-link--select');

  selectInput.change(function(){
    var value = $(this).find("option:selected").attr('value');
    window.location = "http://" + location.hostname + "/solutions/fleet-cards/select/" + value;
  });
}

if ($('#cat').length !== 0) {
    (function() {
      var dropdown = document.getElementById( "cat" );
      function onCatChange() {
        if ( dropdown.options[ dropdown.selectedIndex ].value > 0 ) {
          dropdown.parentNode.submit();
        }
      }
      dropdown.onchange = onCatChange;
    })();
}